import AppRoutes from "./routes/AppRoutes";
import { ChatProvider } from "./context/ChatContext.jsx";

function App() {
  return (
    <div className="App notranslate" translate="no">
      <ChatProvider>
        <AppRoutes />
      </ChatProvider>
    </div>
  );
}

export default App;
